import React from 'react';

import { ListItem, UnorderedList } from '@chakra-ui/react';

export const renderKnowledgeBaseList = (list: string[]) => (
  <UnorderedList spacing={1}>
    {list.map((item, index) => (
      <ListItem pl={3} key={index + '-list'}>
        {item}
      </ListItem>
    ))}
  </UnorderedList>
);
